/**
 * Shared Tailwind class builders for the browse/filter sidebar (FiltersDiv)
 * so the homepage and search page stay visually identical.
 */
export const sidebarFocusClass =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--primary)]";

export const getSidebarNavItemClass = (isActive = false, darkMode = false) =>
  `group flex w-full items-center justify-between gap-2 rounded-lg px-3 py-2.5 text-left text-[15px] font-medium leading-5 transition-colors duration-150 hover:transform-none ${sidebarFocusClass} ${isActive
    ? `text-[var(--primary)] ${darkMode ? "bg-white/[0.05]" : "bg-black/[0.05]"}`
    : `text-[var(--text)] hover:text-[var(--primary)] ${darkMode ? "hover:bg-white/[0.04]" : "hover:bg-black/[0.04]"}`
  }`;

export const getSidebarSubItemClass = (isSelected = false) =>
  `capitalize text-left font-medium cursor-pointer rounded-sm text-sm transition-colors duration-150 hover:transform-none hover:text-[var(--primary)] ${sidebarFocusClass} ${isSelected ? "text-[var(--primary)]" : "text-[var(--grey)]"
  }`;

const sidebarActionBaseClass = `flex h-10 w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg border px-4 text-sm font-medium no-underline transition-colors duration-150 hover:transform-none active:opacity-80 ${sidebarFocusClass}`;

export const sidebarPrimaryActionClass = `${sidebarActionBaseClass} border-[var(--primary)] bg-[var(--primary)] text-black hover:border-[var(--hover)] hover:bg-[var(--hover)]`;

export const getSidebarSecondaryActionClass = (darkMode = false) =>
  `${sidebarActionBaseClass} text-[var(--text)] hover:border-[var(--primary)] hover:text-[var(--primary)] ${darkMode ? "border-[#333333] bg-white/[0.03]" : "border-[#cbcbcb] bg-white"
  }`;

export const getSidebarFooterClass = (darkMode = false) =>
  `mt-auto flex w-full flex-col gap-2.5 border-t pt-5 ${darkMode ? "border-[#2a2c2b]" : "border-[#dcdcdc]"
  }`;
